export const colorMapping = {
  Pome: '#2563EB',
  Grapefruit: '#F87171',
  'Dragon Fruit': '#EC4899',
  Potatoes: '#B45309',
  Onions: '#FBBF24',
  Lemon: '#FDE047',
  Orange: '#FB923C',
  'Soft Citrus': '#EA580C',
  Lime: '#84CC16',
  Pomelo: '#10B981',
  Pomegranates: '#F43F5E',
  Blueberry: '#3B82F6',
  Melons: '#A7F3D0',
  Pear: '#BEF264',
  Apple: '#EF4444',
  Plum: '#7C3AED',
  'Interspecific Plum': '#F0ABFC',
  Nectarine: '#99F6E4',
  Apricot: '#F9A8D4',
  Peach: '#6B21A8',
  Grape: '#6B21A8',
  Avocado: '#0D9488',
  Mango: '#F59E0B',
  Litchi: '#06B6D4',
  Kiwi: '#4ADE80',
  'Baby Food': '#7DD3FC',
  'Passion Fruit': '#818CF8',
  Pumpkin: '#D97706',
  Butternut: '#FDE68A',
  Tomatoes: '#DC2626',
  Carrots: '#A21CAF',
};

export const consistentColorPalette = [
  '#34D399',
  '#F97316',
  '#56A0EB',
  '#FACC15',
  '#A78BFA',
  '#38BDF8',
  '#A3E635',
  '#C4B5FD',
  '#F472B6',
  '#0F766E',
  '#FDBA74',
  '#4F46E5',
  '#A5F3FC',
  '#FCA5A5',
  '#1D4ED8',
  '#FCD34D',
  '#ECFCCB',
  '#E879F9',
  '#14B8A6',
  '#FB7185',
  '#DB2777',
  '#FEF08A',
  '#A855F7',
  '#60A5FA',
];
